module.exports = "static/assets/bd1e18eb36346861c5c57be8ed2ba5e3.mp3";